import React from 'react';
import PropTypes from 'prop-types';

import getExperience from './target';

export const ReactTargetContext = React.createContext();

export default class ReactTarget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            experience: false
        };
    }

    componentDidMount() {
        this.initTestState();
    }

    async initTestState() {
        const { mbox, defaultExperience, atProperty } = this.props;
        const experience = await getExperience(
            mbox,
            defaultExperience,
            atProperty
        );
        // eslint-disable-next-line no-console
        console.log(
            `ATarget: using experience: ${experience} for mbox: ${mbox}`
        );
        return this.setState({ experience });
    }

    render() {
        const { children } = this.props;
        const { experience } = this.state;
        if (!experience) return false;

        return typeof children === 'function' ? (
            children(experience)
        ) : (
            <ReactTargetContext.Provider value={{ experience }}>
                {children}
            </ReactTargetContext.Provider>
        );
    }
}

ReactTarget.defaultProps = {
    atProperty: undefined
};

ReactTarget.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
    defaultExperience: PropTypes.string.isRequired,
    mbox: PropTypes.string.isRequired,
    atProperty: PropTypes.string
};
